import * as t from "io-ts";
import { nullable } from "./index";
import { cargoInvoiceStatusT } from "./types";
import { sendErrorReasonT } from "./outgoing-invoice";
export const invoicingSetStatusValueT = t.union([
    t.literal("OPEN"),
    t.literal("READY_FOR_INVOICE"),
    t.literal("NO_PAYMENT"),
    t.literal("CARD_CASH"),
]);
export const invoicingSetStatusT = t.strict({
    cargoIds: t.array(t.string),
    status: invoicingSetStatusValueT,
});
export const bulkInvoiceReqT = t.strict({
    cargoIds: t.array(t.string),
    dueDate: nullable(t.string),
});
export const bulkInvoiceResultT = t.strict({
    results: t.array(t.strict({
        cargoId: t.string,
        ok: t.boolean,
        error: nullable(t.string),
    })),
});
export const createInvoicingOverviewTypes = ({ decimal, }) => {
    const invoicingLineRowT = t.strict({
        cargoId: t.string,
        cargoRef: nullable(t.string),
        clientId: nullable(t.string),
        date: nullable(t.string),
        invoiceRef: nullable(t.string),
        invoiceStatus: cargoInvoiceStatusT,
        deliveryId: nullable(t.string),
        contactName: nullable(t.string),
        routeRef: nullable(t.string),
        truckId: nullable(t.string),
        cargoType: nullable(t.string),
        startPlace: nullable(t.string),
        stopPlace: nullable(t.string),
        driverNames: nullable(t.string),
        driverIds: nullable(t.array(t.string)),
        lineId: nullable(t.string),
        productId: nullable(t.string),
        description: nullable(t.string),
        unitId: nullable(t.string),
        departmentId: nullable(t.string),
        quantity: nullable(decimal),
        amount: nullable(decimal),
        surchargePercentage: nullable(decimal),
        discountPercentage: nullable(decimal),
    });
    const outgoingInvoiceLineRowT = t.strict({
        productId: t.string,
        description: nullable(t.string),
        quantity: decimal,
        unitNetPrice: decimal,
        departmentId: nullable(t.string),
        discountPercentage: nullable(decimal),
    });
    const outgoingInvoiceRowT = t.strict({
        id: t.string,
        clientId: t.string,
        contactName: nullable(t.string),
        date: t.string,
        invoiceRef: nullable(t.string),
        status: t.union([
            t.literal("INVOICE_CREATED"),
            t.literal("INVOICE_SENT"),
            t.literal("INVOICE_FAILED"),
        ]),
        invoicingMode: nullable(t.string),
        dueDate: nullable(t.string),
        total: decimal,
        sendErrorReason: nullable(t.array(sendErrorReasonT)),
        lines: t.array(outgoingInvoiceLineRowT),
    });
    return {
        invoicingLineRowT,
        invoicingLineRowsT: t.array(invoicingLineRowT),
        outgoingInvoiceLineRowT,
        outgoingInvoiceRowT,
        outgoingInvoiceRowsT: t.array(outgoingInvoiceRowT),
    };
};
//# sourceMappingURL=invoicing-overview.js.map